function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var TweetMenuTemplate = require('./tweet-menu.template');
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var TweetMenu = /*#__PURE__*/function () {
  function TweetMenu(app, mod) {
    var _this = this;
    _classCallCheck(this, TweetMenu);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    app.connection.on('redsquare-show-tweet-options', function (tweet, elem) {
      _this.tweet = tweet;
      _this.tweeter = tweet.tx.from[0].publicKey;
      _this.container = elem;
      _this.render();
    });
  }
  return _createClass(TweetMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      this.overlay.remove();
      var is_tweet_mine = false;
      if (this.tweet.tx.from[0].publicKey == this.mod.publicKey) {
        is_tweet_mine = true;
      }
      this.overlay.show(TweetMenuTemplate(this, this.tweet, is_tweet_mine), function () {
        _this2.close();
        if (document.querySelector('.activated-dot-menu')) {
          document.querySelector('.activated-dot-menu').classList.remove('activated-dot-menu');
        }
      });
      var reference = this.container.getBoundingClientRect();
      var new_top = Math.max(0, Math.round(reference.top) - 190);
      var new_left = Math.max(0, Math.round(reference.right) - 280);
      this.overlay.move(new_top, new_left);
      this.overlay.setBackgroundColor('#0003');
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      Array.from(document.querySelectorAll('.tweet-menu-list-item')).forEach(function (item) {
        item.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            var _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _t = e.currentTarget.getAttribute('id');
                  _context.n = _t === 'delete_tweet' ? 1 : _t === 'edit_tweet' ? 2 : _t === 'block_contact' ? 3 : _t === 'report_tweet' ? 4 : _t === 'show_tweet_info' ? 6 : _t === 'hide_tweet' ? 7 : 8;
                  break;
                case 1:
                  _this3.tweet.deleteTweet();
                  return _context.a(3, 8);
                case 2:
                  _this3.tweet.editTweet();
                  return _context.a(3, 8);
                case 3:
                  _this3.blockContact();
                  return _context.a(3, 8);
                case 4:
                  _context.n = 5;
                  return _this3.reportTweet();
                case 5:
                  return _context.a(3, 8);
                case 6:
                  _this3.showTweetInfo();
                  return _context.a(3, 8);
                case 7:
                  _this3.tweet.hideTweet();
                case 8:
                  _this3.overlay.close();
                case 9:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.tweet = null;
      this.container = null;
    }
  }, {
    key: "showTweetInfo",
    value: function showTweetInfo() {
      var _this$tweet;
      if (!((_this$tweet = this.tweet) !== null && _this$tweet !== void 0 && _this$tweet.sources)) {
        alert('No Info Available');
        return;
      }
      var info = '';
      console.debug(this.tweet.sources);
      this.tweet.sources.forEach(function (s) {
        if (s) {
          if (s !== null && s !== void 0 && s.type) {
            info += "Type: ".concat(s.type, "\n");
          }
          if (s !== null && s !== void 0 && s.node) {
            info += "Node: ".concat(s.node, "\n");
          }
          if (s !== null && s !== void 0 && s.ts) {
            info += "TS: ".concat(s.ts, "\n");
          }
          info += '\n========================\n';
        }
      });
      alert(info);
    }
  }, {
    key: "blockContact",
    value: function blockContact() {
      //Also flag the tweet
      this.reportTweet();
      this.app.connection.emit('saito-blacklist', {
        publicKey: this.tweeter,
        duration: -1
      }); // -1 is forever
      siteMessage('User blocked... reloading feed');
      reloadWindow(1500);
    }
  }, {
    key: "reportTweet",
    value: function reportTweet() {
      //let wallet_balance = await this.app.wallet.getBalance('SAITO');

      // restrict moderation
      this.mod.sendFlagTransaction(this.app, this.mod, {
        signature: this.tweet.tx.signature
      }, this.tweet.tx);
      siteMessage('Reporting tweet to moderators...', 3000);
      this.tweet.hideTweet();
    }
  }]);
}();
module.exports = TweetMenu;